/**
 * Turns stored lesson text into plain text.
 * Handles stringified arrays ("['text']"), stray quotes and HTML from the rich text editor.
 * An editor that was emptied stores "<p></p>", which becomes '' here, so callers can use the
 * result to decide whether anything was really written.
 */
export const sanitizeText = (rawText) => {
    if (!rawText) return '';
    let str = String(rawText).trim();

    // Handle stringified arrays like "['content']" or '["content"]'
    if ((str.startsWith("['") && str.endsWith("']")) || (str.startsWith('["') && str.endsWith('"]'))) {
        str = str.slice(2, -2).trim();
    } else if (str.startsWith('[') && str.endsWith(']')) {
        try {
            const parsed = JSON.parse(str);
            if (Array.isArray(parsed)) {
                str = parsed.join(', ');
            } else {
                str = str.slice(1, -1).trim();
            }
        } catch (e) {
            str = str.slice(1, -1).trim();
        }
    }

    // Handle single element leftover quotes
    if ((str.startsWith("'") && str.endsWith("'")) || (str.startsWith('"') && str.endsWith('"'))) {
        str = str.slice(1, -1).trim();
    }

    // Strip HTML tags like <p>, </p>, etc. and non-breaking spaces left by the editor
    str = str.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
    return str;
};
